/**
 * The office's fixed texts for a missed call, one button each in the text dialog. A button replaces what is in the
 * box; the admin can still edit it before sending. The wording is the office's own — change it here.
 */
export const SMS_TEMPLATES = [
    {
        key: 'first',
        label: '1차, 2차 템플릿',
        text: `[발신전용 | 문자 회신시 확인할 수 없습니다]
안녕하세요. A ONE 입니다.
부재중 전화가 확인되어 다시 연락드렸으나 연결이 닿지 않아 문자 남겨드립니다.
내일 미 동부시 오후 8시 이후 201-266-8882 로 다시 연락드리겠습니다.
감사합니다.`,
    },
    {
        key: 'third',
        label: '3차 템플릿',
        text: `[발신전용 | 문자 회신시 확인할 수 없습니다]
안녕하세요. A ONE 입니다.
Missed Call이 확인되어 몇 차례 전화드렸으나, 연결이 닿지 않아 문자드립니다.
문의사항을 저희 이메일 주소(aone@a-oneinstitute.com)로 남겨주시면 감사하겠습니다.
감사합니다.`,
    },
];
